import actionShow from "./actionShow";
import actionList from "./actionList";
import { Rowing } from "@mui/icons-material";

const Action = {
  list: actionList,
  edit: actionShow,
  icon: Rowing
};
export default Action;